module.exports = __webpack_public_path__ + "assets/img/oslomet_logo_white_tekst.d6af8c70.svg";